import React from "react";
import ManagementNavbar from "./ManagementNavbar";
import {
    Alert,
    Autocomplete,
    Avatar,
    Box,
    Button,
    Card,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Grow,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Snackbar,
    TextField,
} from "@mui/material";
import CourseData from "../../backend/dataservices/CourseData";
import AddIcon from "@mui/icons-material/Add";
import Backend from "../../backend/Backend"
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import ModeIcon from '@mui/icons-material/Mode';
import InfoIcon from '@mui/icons-material/Info';
import {DesktopDateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import deLocale from 'date-fns/locale/de';
import CourseDateData from "../../backend/dataservices/CourseDateData";

function createSuggestionsData(_name, _course) {
    return {name: _name, course: _course};
}

export default function ManagementCoursesPage() {

    const [suggestions, setSuggestions] = React.useState([]);
    const [openSuggestion, setOpenSuggestion] = React.useState(false);
    const [suggestionValue, setSuggestionValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [loadedCourse, setLoadedCourse] = React.useState(null);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarText, setSnackbarText] = React.useState("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
    const [newCourse, setNewCourse] = React.useState(false);
    const [courseDates, setCourseDates] = React.useState([]);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [dialogTitle, setDialogTitle] = React.useState("");
    const [startDateValue, setStartDateValue] = React.useState(new Date());
    const [endDateValue, setEndDateValue] = React.useState(new Date());
    const [locationText, setLocationText] = React.useState("");
    const [speakerText, setSpeakerText] = React.useState("");
    const [notesText, setNotesText] = React.useState("");
    const [createNewDate, setCreateNewDate] = React.useState(true);
    const [editingDate, setEditingDate] = React.useState(null);
    const [openInformationDialog, setOpenInformationDialog] = React.useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    // const [deletable, setDeletable] = React.useState(false);
    // const [showDeleteButton, setShowDeleteButton] = React.useState(false);
    const [courseData, setCourseData] = React.useState({
        courseID: 0,
        courseName: '',
        courseDuration: 0,
        coursePrice: 0,
        courseNotes: '',
        courseNumber: '',
        saveLink: ''
    });
    const [originalCourseData, setOriginalCourseData] = React.useState({
        courseID: 0,
        courseName: '',
        courseDuration: 0,
        coursePrice: 0,
        courseNotes: '',
        courseNumber: '',
        saveLink: ''
    });


    async function searchCourse(name) {
        setLoading(true);
        return CourseData.searchCourse(name).then(generateSuggestions);
    }

    async function loadDataFromDatabase(rawCourseData) {
        let tempRows = [];
        for (const course of rawCourseData) {
            tempRows.push(createSuggestionsData(course.KS_Kursname, course));
        }
        return tempRows;
    }

    function generateSuggestions(rawCourseData) {
        loadDataFromDatabase(rawCourseData).then(data => {
            setSuggestions(data);
            setLoading(false);
        });
    }

    function handleInputValue(value) {
        setNewCourse(false);
        if (value != null) {
            let course = value.course;
            setLoadedCourse(course);
            let data = {
                courseID: course.KS_ID === null ? 0 : course.KS_ID,
                courseName: course.KS_Kursname === null ? '' : course.KS_Kursname,
                courseDuration: course.KS_Dauer === null ? 0 : course.KS_Dauer,
                coursePrice: course.KS_Preis === null ? 0 : course.KS_Preis,
                courseNotes: course.KS_Bemerkungen === null ? '' : course.KS_Bemerkungen,
                courseNumber: course.KS_ZPNummer === null ? '' : course.KS_ZPNummer,
                saveLink: course._links.self.href,
            };
            setCourseData(data);
            setOriginalCourseData(data);
            loadCourseDates(course.KS_ID)
            // checkForDeletable(course)
        } else {
            // setShowDeleteButton(false);
            clearAllData();
            setCourseDates([]);
        }
    }

    // Die Setter uebernehmen den bisherigen Stand per Spread. Wurden die Felder
    // einzeln aufgezaehlt, gingen courseID und saveLink verloren und ein
    // anschliessendes Speichern lief ins Leere.
    function changeCourseName(event) {
        setCourseData({...courseData, courseName: event.target.value});
    }

    function changeCourseID(courseID) {
        setCourseData({...courseData, courseID: courseID});
    }

    function changeCourseDuration(event) {
        setCourseData({...courseData, courseDuration: event.target.value});
    }

    function changeCoursePrice(event) {
        setCourseData({...courseData, coursePrice: event.target.value});
    }

    function changeCourseNotes(event) {
        setCourseData({...courseData, courseNotes: event.target.value});
    }

    function changeCourseNumber(event) {
        setCourseData({...courseData, courseNumber: event.target.value});
    }

    function resetChanges() {
        setCourseData(originalCourseData);
        setNewCourse(false);
    }
    // Direkt nach dem Anlegen kennt das Formular noch keinen self-Link, und die
    // Feld-Setter verwerfen ihn ohnehin bei jeder Aenderung. Aus der Kurs-ID
    // laesst er sich rekonstruieren.
    function saveLink() {
        return originalCourseData.saveLink ? originalCourseData.saveLink : '/api/TAB_KURSSTAMMDATEN/' + courseData.courseID;
    }

    function saveChanges() {
        let course = newCourse ? {} : loadedCourse;
        course.KS_Kursname = courseData.courseName;
        course.KS_Dauer = courseData.courseDuration;
        course.KS_Preis = courseData.coursePrice;
        course.KS_Bemerkungen = courseData.courseNotes;
        course.KS_ZPNummer = courseData.courseNumber;
        delete course._links;
        if (newCourse) {
            course.KS_Kurstechnik = "Sonstige";
            Backend.postData('/api/TAB_KURSSTAMMDATEN', course).then(value => {
                setSnackbarSeverity("success");
                setSnackbarText('Kurs erfolgreich angelegt!');
                setSnackbarOpen(true);
                changeCourseID(value.id);
                setOriginalCourseData(courseData);
                // Das Formular muss in den Bearbeiten-Modus wechseln, sonst legt
                // jeder weitere Klick auf Speichern einen weiteren Kurs an. Der
                // neue Kurs wird dabei zum ausgewaehlten Kurs, damit das Formular
                // geoeffnet bleibt und direkt Termine angelegt werden koennen.
                const angelegterKurs = {KS_ID: value.id, KS_Kursname: courseData.courseName};
                setLoadedCourse(angelegterKurs);
                setSuggestionValue(createSuggestionsData(courseData.courseName, angelegterKurs));
                setNewCourse(false);
            }, (error) => {
                setSnackbarSeverity("error");
                setSnackbarText('Ein unerwarteter Fehler ist aufgetreten');
                setSnackbarOpen(true);
            });
        } else {
            Backend.putData(saveLink(), course).then((res) => {
                setSnackbarSeverity("success");
                setSnackbarText('Änderungen erfolgreich gespeichert!');
                setSnackbarOpen(true);
                setOriginalCourseData(courseData);
            }, (error) => {
                setSnackbarSeverity("error");
                setSnackbarText('Ein unerwarteter Fehler ist aufgetreten');
                setSnackbarOpen(true);
            });
        }
    }

    function closeSnackbar() {
        setSnackbarOpen(false);
    }

    function deleteCourse() {
        CourseData.deleteCourse(courseData.courseID).then(() => {
            setSnackbarSeverity("success");
            setSnackbarText('Kurs erfolgreich gelöscht!');
            setSnackbarOpen(true);
            setOpenDeleteDialog(false);
            setSuggestionValue(null);
            setInputValue('');
            setSuggestions([]);
            handleInputValue(null);
        }, (error) => {
            setSnackbarSeverity("error");
            setSnackbarText('Ein unerwarteter Fehler ist aufgetreten');
            setSnackbarOpen(true);
            setOpenDeleteDialog(false);
        });
    }

    function clearAllData() {
        setCourseData({
            courseID: 0,
            courseName: '',
            courseDuration: 0,
            coursePrice: 0,
            courseNotes: '',
            courseNumber: '',
            saveLink: ''
        });

        setOriginalCourseData({
            courseID: 0,
            courseName: '',
            courseDuration: 0,
            coursePrice: 0,
            courseNotes: '',
            courseNumber: '',
            saveLink: ''
        });
    }

    function createNewCourse() {
        setSuggestionValue(null);
        setNewCourse(true);
        setCourseDates([]);
        clearAllData();
    }

    function saveDate() {

        let start = new Date(startDateValue);
        let end = new Date(endDateValue);

        let date = {
            KD_Anfangstag: start,
            KD_Letzter_Tag: end,
            KD_Beginn: start.getTime(),
            KD_Ende: end.getTime(),
            KD_Veranstaltungsort: locationText,
            KD_Referent: speakerText,
            KD_Bemerkungen: notesText,
            KD_Kursstamm_ID: courseData.courseID,
            KD_ID: createNewDate ? null : editingDate.KD_ID
        };

        if (createNewDate) {
            delete date.KD_ID;
            CourseDateData.saveNewDate(courseData.courseID, date).then(value => {
                setSnackbarSeverity("success");
                setSnackbarText("Neuer Termin erfolgreich angelegt!");
                setSnackbarOpen(true);
            }, (error) => {
                setSnackbarSeverity("error");
                setSnackbarText("Ein unerwarteter Fehler ist aufetreten");
                setSnackbarOpen(true);
            }).then(() => {
                closeDialog();
                loadCourseDates(suggestionValue != null ? suggestionValue.course.KS_ID : courseData.courseID);
            })
        } else {
            CourseDateData.updateDate(date).then(value => {
                setSnackbarSeverity("success");
                setSnackbarText("Termin erfolgreich editiert!");
                setSnackbarOpen(true);
            }, (error) => {
                setSnackbarSeverity("error");
                setSnackbarText("Ein unerwarteter Fehler ist aufetreten");
                setSnackbarOpen(true);
            }).then(() => {
                closeDialog();
                loadCourseDates(suggestionValue != null ? suggestionValue.course.KS_ID : courseData.courseID);
            })
        }
    }

    function loadCourseDates(courseID) {
        CourseData.fetchDatesByCourseID(courseID).then(dates => {
            getCourseDatesArray(dates);
        });
    }

    function getCourseDatesArray(courseDates) {
        let dates = [];
        if (courseDates != null && courseDates !== '') {
            courseDates.forEach(function (value) {
                dates.push(value);
            });
        }
        dates.sort((a, b) => {return (new Date(b.KD_Anfangstag) - new Date(a.KD_Anfangstag))})
        setCourseDates(dates);
    }

    function getDateText(date) {
        let start = date.KD_Anfangstag;
        let end = date.KD_Letzter_Tag;
        return new Date(start).toLocaleDateString('de-DE') + " - " + new Date(end).toLocaleDateString('de-DE');
    }

    function getLocationText(date) {
        if (date.KD_Veranstaltungsort == null) {
            return "Ort nicht gesetzt"
        }
        return "Ort: " + date.KD_Veranstaltungsort;
    }

    function closeDialog() {
        setOpenDialog(false);
    }

    function handleLocationText(event) {
        setLocationText(event.target.value)
    }

    function handleSpeakerText(event) {
        setSpeakerText(event.target.value);
    }

    function handleNotesText(event) {
        setNotesText(event.target.value);
    }

    function clearDialogData() {
        setLocationText("");
        setNotesText("");
        setSpeakerText("");
        setStartDateValue(new Date());
        startDateValue.getMonth()
        setEndDateValue(new Date());
        setEditingDate(null);
    }

    function openDialogForEditing(date) {
        setCreateNewDate(false);
        setEditingDate(date);
        setDialogTitle("Termin editieren");
        setStartDateValue(new Date(date.KD_Beginn == null ? date.KD_Anfangstag : date.KD_Beginn));
        setEndDateValue(new Date(date.KD_Ende == null ? date.KD_Letzter_Tag : date.KD_Ende));
        setLocationText(date.KD_Veranstaltungsort);
        setNotesText(date.KD_Bemerkungen);
        setSpeakerText(date.KD_Referent);
        setOpenDialog(true);
    }

    return (
        <div>
            <ManagementNavbar initValue={"/management/courses"}/>
            <Box width={'100%'} style={{
                borderBottom: '1px solid lightgrey',
                paddingTop: '10px',
                paddingBottom: '20px',
                marginBottom: '10px',
            }}>
                <Grid container spacing={4} style={{alignItems: 'center', justifyContent: 'center'}}>
                    <Grid item xs={1}/>
                    <Grid item xs={8}>
                        <Autocomplete options={suggestions}
                                      fullWidth
                                      open={openSuggestion}
                                      onOpen={() => {
                                          setOpenSuggestion(true)
                                      }}
                                      onClose={() => {
                                          setOpenSuggestion(false)
                                      }}
                                      inputValue={inputValue}
                                      onInputChange={(event, newInputValue) => {
                                          setInputValue(newInputValue)
                                          if (newInputValue.length >= 2) {
                                              searchCourse(newInputValue);
                                          }
                                      }}

                                      value={suggestionValue}
                                      onChange={(event, newInputValue) => {
                                          setSuggestionValue(newInputValue);
                                          handleInputValue(newInputValue);
                                      }}
                                      isOptionEqualToValue={(option, value) => option.name.includes(value.name)}
                                      getOptionLabel={(option) => option.name}
                                      renderInput={(params => (
                                          <TextField
                                              {...params}
                                              variant={"outlined"}
                                              label={"Suche..."}
                                              sx={{width: '100%',}}
                                              InputProps={{
                                                  ...params.InputProps,
                                                  endAdornment: (
                                                      <React.Fragment>
                                                          {loading ? <CircularProgress color={"primary"}/> : null}
                                                          {params.InputProps.endAdornment}
                                                      </React.Fragment>
                                                  ),
                                              }}
                                          />
                                      ))}/>
                    </Grid>
                    <Grid item xs={2}>

                        <Button variant={"contained"} endIcon={<AddIcon/>}
                                style={{width: '80%'}} onClick={createNewCourse}>
                            Kurs anlegen
                        </Button>
                    </Grid>
                    <Grid item xs={1}>
                    </Grid>
                </Grid>
            </Box>

            <div style={{margin: '0 10px 0 10px'}}>
                <Grid container spacing={{xs: 2}}>
                    <Grid item xs={12}>
                        <div style={{textAlign: 'center', height: '30px'}}>
                            {courseData.courseName != null && courseData.courseName !== '' ?
                                <h2>{courseData.courseName}</h2>
                                :
                                <h2> </h2>}
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <Card sx={{minWidth: '100%', maxHeight: '100%', height: '100%'}}
                              style={{backgroundColor: 'rgb(239,239,239)'}}>
                            {(suggestionValue != null || newCourse) ?
                                <Box style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center', margin: '10px 10px 10px 10px', flexDirection: 'column'
                                }}>
                                    <TextField label={'Kursname'} style={{width: '90%'}} variant={'outlined'}
                                               margin={"normal"} value={courseData.courseName}
                                               onChange={changeCourseName}/>

                                    <TextField label={'Kursdauer (in Stunden)'} style={{width: '90%'}} variant={'outlined'}
                                               margin={"normal"} value={courseData.courseDuration}
                                               onChange={changeCourseDuration} type={'number'}/>

                                    <TextField label={'Preis'} style={{width: '90%'}} variant={'outlined'}
                                               margin={"normal"} value={courseData.coursePrice}
                                               onChange={changeCoursePrice} type={'number'}/>

                                    <TextField label={'Bemerkungen'} style={{width: '90%'}} variant={'outlined'}
                                               margin={"normal"} value={courseData.courseNotes}
                                               onChange={changeCourseNotes}/>

                                    <TextField label={'Kursnummer'} style={{width: '90%'}} variant={'outlined'}
                                               margin={"normal"} value={courseData.courseNumber}
                                               onChange={changeCourseNumber} disabled={!newCourse}/>

                                    <div style={{
                                        display: 'flex',
                                        marginTop: '20px',
                                        alignItems: 'center',
                                        justifyContent: 'center', width: '90%'
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <Button style={{color: "gray"}} fullWidth color={'inherit'}
                                                        onClick={resetChanges} variant={'outlined'}
                                                        disabled={originalCourseData === courseData}>
                                                    Änderungen verwerfen
                                                </Button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                {!newCourse ?
                                                    <Button color={'error'} fullWidth variant={'outlined'}
                                                            onClick={() => setOpenDeleteDialog(true)}>
                                                        Kurs löschen
                                                    </Button>
                                                    : null}
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button color={'primary'} fullWidth onClick={saveChanges}
                                                        variant={'outlined'}
                                                        disabled={originalCourseData === courseData || courseData.courseName === '' || courseData.courseName == null}>
                                                    Änderungen speichern
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Box>
                                :
                                null}
                        </Card>
                    </Grid>
                    <Grid item xs={6}>
                        <Card sx={{minWidth: '100%', maxHeight: 420, height: '100%'}}
                              style={{backgroundColor: 'rgb(239,239,239)'}}>
                            {(suggestionValue != null || newCourse) ?
                                <Box style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center', flexDirection: 'column',
                                    maxHeight: '100%'
                                }}>
                                    <Grid container spacing={2} style={{
                                        borderBottom: '1px solid grey',
                                        paddingBottom: '10px',
                                        paddingTop: '10px',
                                    }}>
                                        <Grid item xs={9} textAlign={'center'}>
                                            <h3>Termine</h3>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Button variant={"contained"} endIcon={<MoreTimeIcon/>}
                                                    style={{marginLeft: '30px'}} onClick={() => {
                                                setOpenDialog(true);
                                                setDialogTitle("Neuen Termin anlegen");
                                                clearDialogData();
                                                setCreateNewDate(true);
                                            }}>
                                                Neuen Termin anlegen
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <List sx={{width: '100%', overflow: 'auto'}}>
                                        {courseDates.map((date) => {
                                            return (
                                                <ListItem
                                                    key={date.KD_ID}>
                                                    <ListItemAvatar>
                                                        <Avatar>
                                                            <CalendarMonthTwoToneIcon/>
                                                        </Avatar>
                                                    </ListItemAvatar>

                                                    <ListItemText primary={getDateText(date)}
                                                                  secondary={getLocationText(date)}/>

                                                    <ListItemSecondaryAction>
                                                        <IconButton onClick={() => {
                                                            setEditingDate(date);
                                                            setOpenInformationDialog(true);
                                                        }}>
                                                            <InfoIcon/>
                                                        </IconButton>
                                                        <IconButton edge={'end'}
                                                                    onClick={() => openDialogForEditing(date)}>
                                                            <ModeIcon/>
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            );

                                        })}
                                    </List>
                                </Box>
                                :
                                null}
                        </Card>
                    </Grid>
                </Grid>
            </div>

            <Dialog open={openDialog} onClose={closeDialog}>
                <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                    {dialogTitle}
                </DialogTitle>
                <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <DesktopDateTimePicker label={"Startzeitpunkt"}
                                                       onChange={(newValue) => {
                                                           setStartDateValue(newValue)
                                                       }}
                                                       value={startDateValue}
                                                       renderInput={(params) => <TextField {...params}
                                                                                           margin={"normal"}
                                                                                           fullWidth/>}/>
                            </Grid>
                            <Grid item xs={6}>
                                <DesktopDateTimePicker label={"Endzeitpunkt"}
                                                       onChange={(newValue) => {
                                                           setEndDateValue(newValue)
                                                       }}
                                                       value={endDateValue}
                                                       renderInput={(params) => <TextField {...params}
                                                                                           margin={"normal"}
                                                                                           fullWidth/>}/>
                            </Grid>
                        </Grid>
                    </LocalizationProvider>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField fullWidth variant={'standard'} label={"Ort"} required
                                       onChange={handleLocationText} value={locationText}/>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField fullWidth variant={'standard'} label={"Referent"} onChange={handleSpeakerText}
                                       value={speakerText}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth variant={'standard'} label={"Bemerkungen"} onChange={handleNotesText}
                                       value={notesText}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button style={{color: "gray"}} onClick={closeDialog}>Abbrechen</Button>
                    <Button disabled={startDateValue > endDateValue || locationText == null || locationText === ''}
                            color={"primary"} onClick={saveDate}>Speichern</Button>
                </DialogActions>
            </Dialog>

            {editingDate != null ?
                <Dialog open={openInformationDialog} fullWidth onClose={() => setOpenInformationDialog(false)}>
                    <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                        Kurstermin für {originalCourseData.courseName}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <p>Von:</p>
                                <p>Bis:</p>
                                <p>Ort:</p>
                                <p>Referent:</p>
                                <p>Bearbeiter:</p>
                                <p>Bemerkungen:</p>
                            </Grid>
                            <Grid item xs={7}>
                                <p>{editingDate.KD_Beginn == null ? new Date(editingDate.KD_Anfangstag).toLocaleDateString('DE-de') : new Date(editingDate.KD_Anfangstag).toLocaleDateString('DE-de') + " - " + new Date(editingDate.KD_Beginn).toLocaleTimeString('DE-de',  {hour: '2-digit', minute:'2-digit'})}</p>
                                <p>{editingDate.KD_Ende == null ? new Date(editingDate.KD_Letzter_Tag).toLocaleDateString('DE-de') : new Date(editingDate.KD_Letzter_Tag).toLocaleDateString('DE-de') + " - " + new Date(editingDate.KD_Ende).toLocaleTimeString('DE-de',  {hour: '2-digit', minute:'2-digit'})}</p>
                                <p>{editingDate.KD_Veranstaltungsort == null ?
                                    <em>Nicht gesetzt</em> : editingDate.KD_Veranstaltungsort}</p>
                                <p>{editingDate.KD_Referent == null ?
                                    <em>Nicht gesetzt</em> : editingDate.KD_Referent}</p>
                                <p>{editingDate.KD_Bearbeiter == null ?
                                    <em>Nicht gesetzt</em> : editingDate.KD_Bearbeiter}</p>
                                <p>{editingDate.KD_Bemerkungen == null ?
                                    <em>Nicht gesetzt</em> : editingDate.KD_Bemerkungen}</p>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
                : null
            }
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                    Kurs löschen
                </DialogTitle>
                <DialogContent>
                    <p>Soll der Kurs "{courseData.courseName}" wirklich gelöscht werden?</p>
                    <p>Der Kurs wird anschließend nicht mehr angezeigt. Bereits erfasste
                        Teilnahmen der Mitarbeiter bleiben erhalten.</p>
                </DialogContent>
                <DialogActions>
                    <Button style={{color: "gray"}} onClick={() => setOpenDeleteDialog(false)}>Abbrechen</Button>
                    <Button color={"error"} onClick={deleteCourse}>Löschen</Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={closeSnackbar}
                      anchorOrigin={{vertical: "top", horizontal: "right"}} TransitionComponent={Grow}>
                <Alert onClose={closeSnackbar} severity={snackbarSeverity} sx={{width: '100%'}}>
                    {snackbarText}
                </Alert>
            </Snackbar>
        </div>
    )

}